import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CarouselCP = ({ items }) => {
  const carouselControls = items.length > 1;

  return (
    <div className="container-fluid px-0">

      <Carousel controls={carouselControls} className="mb-0">
        {items.map((i) => (
          <Carousel.Item key={i.id}>
            <Row>
              <Col lg={6} className="px-0 d-lg-none d-xl-none">
                <img
                  className="d-block w-100"
                  src={i.imageUrlMobile}
                  alt={i.title}
                  width="100%"
                  height="140" />
              </Col>
              <Col lg={6} className="bg-tangaroa">
                <div className="caption-cp">
                  <h1 className="text-white">
                    {i.title}
                  </h1>
                  <p className="text-white my-15">
                    {i.description}
                  </p>
                  <Link to={`/subastas/${i.auction.urlName}/${i.auction.id}`} className="btn btn-primary-dark">
                    {i.buttonText}
                  </Link>
                </div>
              </Col>
              <Col lg={6} className="px-0 d-none d-lg-block d-xl-block">
                <img
                  className="d-block w-100 bnn-height"
                  src={i.imageUrl}
                  alt={i.title}
                  width="623" />
              </Col>
            </Row>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

CarouselCP.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    imageUrlMobile: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
  })).isRequired,
};

export default CarouselCP;
